'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _class = function () {
	/*@ngInject*/
	function _class(data, $filter, $http) {
		_classCallCheck(this, _class);

		this.data = data;
		this.student = data.student;
		this.tutor = data.tutor;
		this.isTutor = data.isTutor;
		this.$filter = $filter;
		this.$http = $http;
		this.isTomorrow = data.isTomorrow;
	}

	_createClass(_class, [{
		key: '$onInit',
		value: function $onInit() {
			var _this = this;

			this.error = null;
			this.changed = false;
			if (this.isTutor) {
				this.setNumber(this.tutor.phone);
			} else {
				this.setNumber(this.student.clientPh);
			}

			this.setField('parent', this.student.clientFirstName, true);
			this.setField('studentName', this.student.firstName, true);
			this.setField('tutorName', this.tutor.firstName);

			var tomorrow = new Date();
			tomorrow.setDate(tomorrow.getDate() + 1);
			tomorrow = this.$filter('date')(tomorrow, 'dd/MM');

			this.date = this.$filter('date')(new Date(), 'dd/MM');
			this.time = this.$filter('segmentConvert')(this.data.time);
			if (!this.isTutor) {
				if (this.isTomorrow) {
					this.message = 'Hi ' + this.parent + '! Just a reminder that ' + this.studentName + ' has tuition tomorrow (' + tomorrow + ') at ' + this.time + '. Thanks, Pat (Personal Tutors)';
				} else {
					this.message = 'Hi ' + this.parent + '! Just a reminder that ' + this.studentName + ' has tuition this afternoon (' + this.date + ') at ' + this.time + '. Thanks, Pat (Personal Tutors)';
				}
			} else {
				if (this.isTomorrow) {
					this.message = 'Hi ' + this.tutorName + '! Just a reminder that you tutor tomorrow (' + tomorrow + ') from ' + this.time + ' to ' + this.time + ' (0 Hours). Thanks, Pat (Personal Tutors)';
				} else {
					this.message = 'Hi ' + this.tutorName + '! Just a reminder that you tutor this afternoon (' + this.date + ') from ' + this.time + ' to ' + this.time + ' (0 Hours). Thanks, Pat (Personal Tutors)';
				}
			}

			this.$http.get('/api/smssettings').then(function (response) {
				_this.defaultSenderNumber = response.data[0].mobileNumber1;
				_this.sendernumbers = [response.data[0].mobileNumber1, response.data[0].mobileNumber2, response.data[0].mobileNumber3];
			});
		}
	}, {
		key: 'setNumber',
		value: function setNumber(data) {
			if (!data) {
				return;
			}
			data = data.replace(' ', '');
			this.phone = data;
		}
	}, {
		key: 'setField',
		value: function setField(field, data, forStudent) {
			if (!data) {
				if (forStudent && !this.isTutor || this.isTutor && !forStudent) {
					this.error = 'Not all fields are set. Please revise.';
				}
			}
			this[field] = data || 'Unset';
		}
	}, {
		key: 'postSMS',
		value: function postSMS(phone, callback) {
			var _this2 = this;

			var message = decodeURI(this.message);
			this.$http.post('http://api.smsbroadcast.com.au/api-adv.php?username=pspeare&password=GSPT2011&to=' + phone + '&from=' + this.defaultSenderNumber + '&message=' + message).then(function (res) {
				callback(_this2.saveType);
			}).catch(function (res) {
				_this2.error = "Something went wrong.";
			});
		}
	}, {
		key: 'submit',
		value: function submit(callback) {
			var _this3 = this;

			this.error = null;
			var phone = this.phone.replace(' ', '');
			if (this.isTutor) {
				if (this.save) {
					console.log('saving');
					this.tutor.phone = phone;
					this.saveType = 'changed';
					this.$http.put('/api/tutors/' + this.tutor._id, this.tutor).then(function (res) {
						_this3.postSMS(phone, callback);
					}).catch(function (res) {
						_this3.error = 'Error when saving. SMS not sent. Please refresh.';
					});
				} else {
					this.saveType = 'success';
					this.postSMS(phone, callback);
				}
			} else {
				if (this.save) {
					console.log('saving');
					this.student.clientPh = phone;
					this.saveType = 'changed';
					this.$http.put('/api/students/' + this.student._id, this.student).then(function (res) {
						_this3.postSMS(phone, callback);
					}).catch(function (res) {
						_this3.error = 'Error when saving. SMS not sent. Please refresh.';
					});
				} else {
					this.saveType = 'success';
					this.postSMS(phone, callback);
				}
			}
		}
	}]);

	return _class;
}();

exports.default = _class;


// WEBPACK FOOTER //
// ./client/app/calendar/send-sms/send-sms.controller.js